import { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import PreviewSidebar from './components/PreviewSidebar'
import CreateSidebar from './components/CreateSidebar'
import DeleteSidebar from './components/DeleteSidebar'
import EditSidebar from './components/EditSidebar'
import ReorderContentSidebar from './components/ReorderContentSidebar'

import { CategoryDto } from '../../../types/category'

interface ComponentProps {
  group,
  groupStates,
  categories,
  idCategoryToOrder?: number
  categoryToEdit?: CategoryDto
  categoriesState,
  showCategories,
  showCreateCategory,
  showReorderContent?,
  setCategoryManagerVisible?
  onClose,
}

const Component = ({
  group,
  groupStates,
  categories,
  idCategoryToOrder,
  categoryToEdit,
  categoriesState,
  showCategories,
  showCreateCategory,
  showReorderContent,
  onClose,
  setCategoryManagerVisible,
}: ComponentProps) => {
  const [showDeleteCategorySidebar, setShowDeleteCategorySidebar] = useState<boolean>(false);
  const [showEditCategorySidebar, setShowEditCategorySidebar] = useState<boolean>(false);
  const [showReorderContentSidebar, setShowReorderContentSidebar] = useState<boolean>(false)
  const [showCreateCategorySidebar, setShowCreateCategorySidebar] = useState<boolean>(false);
  // const [showPreviewCategoriesSidebar, setShowPreviewCategoriesSidebar] = useState<boolean>(false);
  const [selectedCategoryToReorder, setSelectedCategoryToReorder] = useState<number>();
  const [selectedCategorToEdit, setSelectedCategorToEdit] = useState<CategoryDto>();
  const [selectedCategoryToBeDeleted, setSelectedCategoryToBeDeleted] = useState<CategoryDto>();

  useEffect(() => {
    if (categoryToEdit) {
      setSelectedCategorToEdit(categoryToEdit)
      setShowEditCategorySidebar(true)
    } else {
      setSelectedCategorToEdit(undefined)
      setShowEditCategorySidebar(false)
    }
  }, [categoryToEdit?.id])

  return <>
    <PreviewSidebar
      onClose={() => {
        setCategoryManagerVisible(false)
        onClose && onClose()
      }}
      isVisible={showCategories}
      setSelectedCategorToEdit={setSelectedCategorToEdit}
      setSelectedCategoryToBeDeleted={setSelectedCategoryToBeDeleted}
      setShowDeleteCategorySidebar={setShowDeleteCategorySidebar}
      setShowEditCategorySidebar={setShowEditCategorySidebar}
      setShowCreateCategorySidebar={setShowCreateCategorySidebar}
      showCreateCategorySidebar={showCreateCategorySidebar}
    />

    <ReorderContentSidebar
      onClose={() => {
        setShowReorderContentSidebar(false);
        onClose && onClose();
      }}
      isVisible={!!showReorderContentSidebar !== !!showReorderContent}
      idCategory={idCategoryToOrder}
      idGroup={group?.id}
    />

    <CreateSidebar
      onClose={() => {
        setShowCreateCategorySidebar(false);
        onClose && onClose();
      }}
      isVisible={!!showCreateCategorySidebar !== !!showCreateCategory}
    />

    <DeleteSidebar
      category={selectedCategoryToBeDeleted}
      onClose={() => {
        setShowDeleteCategorySidebar(false)
        setSelectedCategoryToBeDeleted(undefined);
        onClose && onClose();
      }}
      isVisible={!!selectedCategoryToBeDeleted}
    />

    {selectedCategorToEdit && (
      <EditSidebar
        category={selectedCategorToEdit}
        onClose={() => {
          setShowEditCategorySidebar(false)
          onClose && onClose()
        }}
        isVisible={showEditCategorySidebar}
      />
    )}
  </>
}

const state = ({ groupStore, categoryStore }) => {
  const { data: categories, states: categoriesState } =
    categoryStore?.allCategories;
  const { data: group, states: groupStates } =
    groupStore.group;

  return {
    group,
    groupStates,
    categories,
    categoriesState,
  };
};

export default connect(state)(Component);